<script setup lang="ts">
import { getLocalTimeZone, today } from "@internationalized/date"

import AppDatePicker from "@/components/AppDatePicker.vue"

defineProps<{ modelValue: string; id?: string; invalid?: boolean }>()
defineEmits<{ "update:modelValue": [string] }>()

const tz = getLocalTimeZone()
const now = today(tz)

// Must be at least 18 years old
const maxDob = now.subtract({ years: 18 }).toString()
// Must be no more than 70 years old
const minDob = now.subtract({ years: 70 }).toString()
</script>

<template>
  <AppDatePicker
    :id="id"
    :model-value="modelValue"
    :min="minDob"
    :max="maxDob"
    :invalid="invalid"
    placeholder="Date of birth"
    required
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>
